export const ENABLE_OPERATOR_SUB_ROLES_UI = false
export const ENABLE_CREW_RANK_PERMISSIONS_UI = true
